import { createSlice } from "@reduxjs/toolkit";
import { defaultAddReducer, defaultSetReducer, defaultUpdateReducer, defaultRemoveReducer } from "./defaultReducer";

const initialState = {
  list: [],
};

const slice = createSlice({
  name: "modules",
  initialState,
  reducers: {
    // Give case reducers meaningful past-tense "event"-style names
    setModulesReducer: defaultSetReducer,
    updateModuleReducer: defaultUpdateReducer,
    addModuleReducer: defaultAddReducer,
    removeModuleReducer: defaultRemoveReducer,
  },
});

// `createSlice` automatically generated action creators with these names.
// export them as named exports from this "slice" file
export const { setModulesReducer, updateModuleReducer, addModuleReducer, removeModuleReducer } = slice.actions;

// Export the slice reducer as the default export
export default slice.reducer;
